module.exports = __webpack_public_path__ + "static/img/new8-Hd6yBx3J.cbf41b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new8-Hd6yBx3J.png
// module id = h/b1
// module chunks = 16